import { render, staticRenderFns } from "./TopTip.vue?vue&type=template&id=1b297af4&scoped=true"
import script from "./TopTip.vue?vue&type=script&lang=js"
export * from "./TopTip.vue?vue&type=script&lang=js"
import style0 from "./TopTip.vue?vue&type=style&index=0&id=1b297af4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b297af4",
  null
  
)

export default component.exports